import React, { Component } from 'react'
import './index.less'
import Header from '../Header'

export default class extends Component {
  render() {
    const { onChangeRule, lang, top, banner, headWear, ruleBg } = this.props
    return (
      <div className='nt-header-wrap' style={{ backgroundImage: `url(${banner})` }}>
        {/* 头像框 */}
        {/* 头像框，头像，背景，高度 */}
        <Header
          userAvatar={top && top.avatarurl || ''}
          scaleSize={1}
          headWear={headWear}
        />

        {/* 规则按钮 */}
        <div className="nt-btn" style={{ backgroundImage: `url(${ruleBg})` }} onClick={() => onChangeRule(true)}>
          {lang.rule}
        </div>

        <div className="fire-gif"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Banner/index.js